<template>
  <div>
    <d-form @submit="toggleLoggedIn">
      <d-form-row>

        <!-- Usuario -->
        <d-col class="form-group">
          <label for="username">Usuário</label>
          <d-form-input @keydown.enter="toggleLoggedIn()" type="text" id="username" placeholder="usuário" v-model="form.username" required/>
        </d-col>

      </d-form-row>
      <d-form-row>

        <!-- Senha -->
        <d-col class="form-group">
          <label for="username">Senha</label>
          <d-form-input @keydown.enter="toggleLoggedIn()" type="password" id="password" placeholder="senha" v-model="form.password" required/>
        </d-col>
      </d-form-row>

      <d-row class="login-form__form__control cotrol">
        <d-col cols="12" class="control__error">
          <span v-if="error">E-mail e/ou senha estão incorretos.</span>
        </d-col>

        <d-col cols="12" class="control__send">
          <div class="control__send__forgot" @click.stop="toggleModal()" >Esqueceu a senha?</div>
          <div class="control__send__button">
            <loader v-if="loading" :fullPage="false" class="mr-4"/>
            <d-button class="btn btn-md btn-primary" >Entrar</d-button>
          </div>
        </d-col>
      </d-row>
      <!--<div v-else class="circle-loader"></div>-->
    </d-form>
    <forget-password-modal></forget-password-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ForgetPasswordModal from '_common/components/forms/ForgetPassword.vue';
import Loader from '_shared/Loader.vue';

export default {
  name: 'login',
  components: {
    Loader,
    ForgetPasswordModal,
  },
  data() {
    return {
      form: {
        username: null,
        password: null,
      },
      error: false,
      loading: false,
      success: false,
    };
  },
  computed: {
    isCustomer() {
      const { isCustomer } = this.$store.state.user;
      return isCustomer;
    },
    userCustomersList: {
      get() {
        const { userCustomersList } = this.$store.state.user;
        return userCustomersList;
      },
      set(newValue) {
        this.$store.commit('setUserCustomersList', newValue);
      },
    },
    hasManyCustomers() {
      const { hasManyCustomers } = this.$store.state.user;
      return hasManyCustomers;
    },
  },
  methods: {
    ...mapActions([
      'login',
      'logout',
      'setToggle',
      'getUserCustomersList',
      'getHasManyCustomers',
    ]),
    toggleLoggedIn(e) {
      e.preventDefault();
      this.loading = true;
      this.logout();
      this.login(this.form)
        .then(() => {
          this.error = false;
          this.loading = false;
          this.success = true;
          return this.updateUserAndCustomers();
        })
        .then(() => this.redirectUser())
        .catch(() => {
          this.loading = false;
          this.error = true;
          this.form.password = '';
        });
    },

    updateUserAndCustomers() {
      return new Promise((resolve, reject) => {
        const { user } = this.$store.state.user;
        this.getUserCustomersList(user.id)
          .then(() => {
            this.getHasManyCustomers(this.userCustomersList);
            resolve();
          })
          .catch(error => {
            console.error('Erro ao atualizar usuário e lista de clientes: ', error);
            reject(error);
          });
      });
    },

    redirectUser() {
      const { redirect } = this.$route.query;

      if (redirect) {
        return this.$router.replace(decodeURIComponent(redirect));
      }

      if (this.isCustomer) {
        if (!this.hasManyCustomers) {
          return this.$router.push(`/admin/clientes/${this.userCustomersList[0].id}`);
        }
        return this.$router.push('/admin/clientes/lista/1');
      }

      return this.$router.push('/admin/overview');
    },

    toggleModal() {
      this.setToggle({ type: 'forgot_password_modal', bool: true });
    },
  },
  mounted() {
    this.userCustomersList = [];
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.login-form {

  width: 100%;
  justify-content: center;

    .control {
    &__send {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      &__button {
        display: flex;
        justify-content: flex-end;
      }
      &__forgot {
        cursor: pointer;
        &:hover {
          color: $primary;
        }
      }
    }
    &__error {
      color: $red;
    }
  }
}
</style>
